import Box from '@mui/material/Box';
import type { ParagraphType } from '@packages/cms-components/interfaces';
import type { CmsData } from '@packages/cms-components/interfaces/webapp_json';
import { createFilterContentSnippetsForCurrentTime } from '@packages/cms-components/src/utils/filterResult';
import { Container } from '@packages/shared';
import ComponentRecognizerFooter from './ComponentRecognizerFooter';
import type { FooterBlockType } from './types';

type AreaTopProps = {
  data: CmsData;
};

export enum AreaTopTestIds {
  top = 'top',
  noRenderComponentFound = 'top-no-component-found',
}

const AreaTop = ({ data }: AreaTopProps): JSX.Element => {
  const filterContentSnippetsForCurrentTime = createFilterContentSnippetsForCurrentTime({});
  const comp = (data.paragraph as FooterBlockType[])
    .filter(
      (item) =>
        item?.parent_field_name === 'field_footer_top' && filterContentSnippetsForCurrentTime(item),
    )
    .map((item: ParagraphType, index) => {
      const currentKey = `${AreaTopTestIds.top}-item-${index}`;
      return <ComponentRecognizerFooter key={currentKey} item={item} />;
    });

  if (comp.length === 0) {
    return (
      <Box
        sx={{
          mt: 5,
        }}
        data-testid={AreaTopTestIds.noRenderComponentFound}
      />
    );
  }

  return <Container data-testid={AreaTopTestIds.top}>{comp}</Container>;
};

// eslint-disable-next-line import/no-default-export
export default AreaTop;
